import { getQueryParams } from 'src/modules/utils';

import { _id } from './test-data';

export const mockError = (queryName: string) => {
  throw new Error(
    `Query ${queryName} failed due to a mock override. This may or may not have been intentional. See testGraphqlMocks.ts if this error was not expected.`,
  );
};

export const getStateTesters = () => {
  const { testData = '' } = getQueryParams(
    typeof window !== 'undefined' ? window.location.href : '',
  );
  const returnState = (name: string, state: string) =>
    testData.indexOf(`${name}:${state}`) !== -1;
  const returnEmptyState = (name: string) => returnState(name, 'empty');
  const returnErrorState = (name: string) => returnState(name, 'error');

  return { returnEmptyState, returnErrorState, returnState };
};

export const handleQueryError = (schemaName: string) => {
  const { returnErrorState } = getStateTesters();

  const name = `${schemaName}:query`;

  if (returnErrorState(name)) {
    mockError(schemaName);
  }
};

export const getItemIndexById = <T extends { id: unknown }>(
  items: T[],
  id: unknown,
) => items.findIndex((item) => item.id === id);

export const mergeItems = <T extends { id: unknown }>(
  items: T[],
  newItem: T,
) => {
  const itemIndex = getItemIndexById(items, newItem.id);

  if (itemIndex !== -1) {
    items.splice(itemIndex, 1, newItem);
    return [...items];
  }

  return [newItem, ...items];
};

export const attachToViewerWithId = <T extends Record<string, unknown>>(
  data: T,
): { viewer: { _id: string } & T } => ({ viewer: { _id, ...data } });
